import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from "classnames";

import RegistrationFormComponent from '../components-new/RegistrationForm/RegistrationForm';
import styles from "./page.module.scss"
import ArrowBackIcon from '../../shared/icons/ArrowBackIcon';
import RegistrationSurveyUserFirst from '../components-new/RegistrationSurveyUserFirst';
import RegistrationSurveyUserSecond from '../components-new/RegistrationSurveyUserSecond';
import SecurityIcon from '../../shared/icons/SecurityIcon';
import RegistrationSurveyUserThird from '../components-new/RegistrationSurveyUserThird';
import { User } from '../../../services';
import { toast } from 'react-toastify';
import { LanguageDropdown } from "../../LanguageSelector/LanguageSelector";
import { USER_TYPE } from '../components-new/RegistrationSurveyUserSecond/RegistrationSurveyUserSecond';

const PageNewRegistration = () => {
  const { t } = useTranslation();
  const rootEl = useRef(null);
  const appendFP = useRef(false);
  const [step, setStep] = useState(localStorage.getItem('step') ? Number(localStorage.getItem('step')) : 1);
  const [data, setData] = useState({})
  const [clientId, setClientId] = useState("")

  const urlParams = new URLSearchParams(window.location.search);
  const codeParam = urlParams.get('code');
  const typeParam = urlParams.get('type');

  useEffect(() => {
    if (codeParam) {
      User.getCodeInfo(codeParam)
      .then(response => {
        if(response.data?.clientId) {
          toast.success(t('registrationPageNew.toast.linkActivated'));
          setClientId(response.data.clientId);
          if (response.data.email) {
            setData(prevData => ({
              ...prevData,
              email: response.data.email
            }));
          }
        } else toast.error(t('registrationPageNew.toast.linkInactive'));
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('registrationPageNew.toast.linkInactive'));
      });
    }
  }, [codeParam]);

  useEffect(() => {
    if (document.getElementById("gtm-script-NXMPGQTD")) return;

    // --- HEAD SCRIPT ---
    const script = document.createElement("script");
    script.id = "gtm-script-NXMPGQTD";
    script.async = true;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-NXMPGQTD');`;
    document.head.prepend(script);

    // --- BODY NOSCRIPT ---
    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript-NXMPGQTD";
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NXMPGQTD"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(noscript);

    return () => {
      // cleanup если компонент размонтируется
      const s = document.getElementById("gtm-script-NXMPGQTD");
      if (s) s.remove();
      const n = document.getElementById("gtm-noscript-NXMPGQTD");
      if (n) n.remove();
    };
  }, []);

  useEffect(() => {
    if (typeParam) {
      const normalizedType = typeParam.toLowerCase();
      if (normalizedType === USER_TYPE.CLIENT || normalizedType === USER_TYPE.EXPEDITOR) {
        setData(prevData => ({ 
          ...prevData, 
          type: normalizedType,
          isHead: true 
        }));
      }
    }
  }, [typeParam]);

  // Meta Pixel Code
  useEffect(() => {
    if (rootEl.current && !appendFP.current) {
      const scriptBody = `
        !function(f,b,e,v,n,t,s) { if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1048831292922421');
        fbq('track', 'PageView');
      `
      const s = document.createElement("script");
      s.type = 'text/javascript';
      s.async = true;
      s.innerHTML = scriptBody;
      rootEl.current.appendChild(s);

      const noS = document.createElement("noscript");
      const img = document.createElement("img");
      img.src = "https://www.facebook.com/tr?id=1048831292922421&ev=PageView&noscript=1"
      img.width = 1
      img.height = 1
      img.style.display = "none"
      noS.appendChild(img);
      rootEl.current.appendChild(noS);
      appendFP.current = true
    }
  }, [rootEl])
  // End Meta Pixel Code

  const renderContent = () => {
    switch (step) {
      case 1:
        return <RegistrationFormComponent updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
      case 2:
        return <RegistrationSurveyUserFirst updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} code={codeParam} clientId={clientId} />
      case 3:
        return <RegistrationSurveyUserSecond updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} code={codeParam} clientId={clientId} />
      case 4:
        return <RegistrationSurveyUserThird updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} code={codeParam} clientId={clientId} />
    }
  }

  const stepDetails = [
    {
      title: t('registrationPageNew.steps.step1.title'),
      text: t('registrationPageNew.steps.step1.text')
    },
    {
      title: t('registrationPageNew.steps.step2.title'),
      text: t('registrationPageNew.steps.step2.text')
    },
    {
      title: t('registrationPageNew.steps.step3.title'),
      text: t('registrationPageNew.steps.step3.text')
    },
    {
      title: t('registrationPageNew.steps.step4.title'),
      text: t('registrationPageNew.steps.step4.text')
    }
  ];


  const previousStep = () => {
    setStep((prevStep) => Math.max(prevStep - 1, 1));
  };

  return (
    <div ref={rootEl} className={styles.containerReg}>

      {/* Form Content */}
      <div className={cn(styles.containerReg_wallpaper)}>

        <div className={styles.card}>

          {/* Header */}
          <div className={styles.card_topbar}>
            <div className={styles.card_logo}>
              <img src="/icons/ic_biny_dark.svg" alt="logo" />
            </div>
            <LanguageDropdown />
          </div>

          {/* Main */}
          <div className={styles.card_content}>
            <div className={styles.card_head}>
              <button type="button" className={styles.card_back} onClick={previousStep} style={{ display: step > 1 ? "block" : "none" }}>
                <ArrowBackIcon />
              </button>
              <div className={styles.card_title}><span>{stepDetails[step - 1].title}</span></div>
              <div className={styles.card_head_text} style={{ display: step > 1 ? "block" : "none" }}>
                <span>{stepDetails[step - 1].text}</span>
              </div>
            </div>

            {renderContent()}

          </div>
          {step > 1 && (
            <div className={styles.card_footer}>
              <SecurityIcon />
              <span>{t('registrationPageNew.footer.securityNotice')}</span>
            </div>
          )}
        </div>

        <div className={styles.right}>
          <div className={styles.banner}>
            <div className={styles.banner_dec}>
              <div className={styles.banner_title}>{t('registrationPageNew.banner.title')}</div>
              <div className={styles.banner_text}>{t('registrationPageNew.banner.text')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNewRegistration;
